import { Select } from 'peach/components'

import stateCodes from './stateCodes'

const StateCodeSelect = (props) => (
  <Select options={stateCodes} searchable {...props} />
)

export default StateCodeSelect
